import { formatDistanceToNowStrict, format } from "date-fns";
import { es } from "date-fns/locale";

const nfEntero = new Intl.NumberFormat("es-MX", { maximumFractionDigits: 0 });
const nfDecimal = new Intl.NumberFormat("es-MX", { maximumFractionDigits: 3 });

/** 1250 → "1,250"; 12.5 → "12.5"; sin ".000" cuando el número es entero. */
export function num(v: number | string | null | undefined): string {
  if (v === null || v === undefined || v === "") return "—";
  const n = typeof v === "string" ? Number(v) : v;
  if (!Number.isFinite(n)) return "—";
  return Number.isInteger(n) ? nfEntero.format(n) : nfDecimal.format(n);
}

export function cantidad(v: number | string | null | undefined, unidad?: string | null): string {
  const base = num(v);
  return unidad ? `${base} ${unidad.toLowerCase()}` : base;
}

export function hace(fecha: string | Date | null | undefined): string {
  if (!fecha) return "nunca";
  return `hace ${formatDistanceToNowStrict(new Date(fecha), { locale: es })}`;
}

export function fechaHora(fecha: string | Date | null | undefined): string {
  if (!fecha) return "—";
  return format(new Date(fecha), "d MMM yyyy, HH:mm", { locale: es });
}

export function fechaCorta(fecha: string | Date | null | undefined): string {
  if (!fecha) return "—";
  return format(new Date(fecha), "d MMM, HH:mm", { locale: es });
}

export function signo(delta: number | string | null | undefined): string {
  const n = Number(delta ?? 0);
  if (n > 0) return `+${num(n)}`;
  if (n < 0) return `−${num(Math.abs(n))}`;
  return "0";
}

export const MOTIVOS_ENTRADA: { valor: string; etiqueta: string }[] = [
  { valor: "recepcion", etiqueta: "Recepción de mercancía" },
  { valor: "devolucion_cliente", etiqueta: "Devolución de cliente" },
  { valor: "otro", etiqueta: "Otro" },
];

export const MOTIVOS_BAJA: { valor: string; etiqueta: string; soloManual?: boolean }[] = [
  { valor: "merma", etiqueta: "Merma (se echó a perder)" },
  { valor: "dano", etiqueta: "Daño (se rompió)" },
  { valor: "robo", etiqueta: "No localizado" },
  { valor: "muestra", etiqueta: "Muestra a cliente" },
  { valor: "obra", etiqueta: "Salida a obra" },
  { valor: "venta", etiqueta: "Venta", soloManual: true },
  { valor: "otro", etiqueta: "Otro" },
];

export function etiquetaMotivo(motivo: string | null | undefined): string {
  if (!motivo) return "";
  const todos = [...MOTIVOS_ENTRADA, ...MOTIVOS_BAJA, { valor: "traspaso_salida", etiqueta: "Traspaso (salida)" }, { valor: "traspaso_entrada", etiqueta: "Traspaso (entrada)" }];
  return todos.find((m) => m.valor === motivo)?.etiqueta ?? motivo;
}

export function etiquetaTipo(tipo: string | null | undefined): string {
  switch (tipo) {
    case "conteo": return "Conteo";
    case "entrada": return "Entrada";
    case "baja": return "Baja";
    case "transferencia": return "Traspaso";
    default: return tipo ?? "";
  }
}

export function etiquetaEstado(estado: string | null | undefined): string {
  switch (estado) {
    case "agotado": return "Agotado";
    case "bajo": return "Bajo mínimo";
    case "sin_minimo": return "Sin mínimo";
    case "ok": return "En orden";
    default: return "";
  }
}
